import { NumericIcon } from './NumericIcon';

/**
 * author: Austin Andrews
 * id 1293DBCD-E538-4AD1-97C9-3F17BBD28457
 * name numeric
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric.svg
 * tags
 * - Alpha / Numeric 
 */
export const OneTwoThreeIcon = NumericIcon;
export default OneTwoThreeIcon